import { forwardRef } from "react"
import type { AnchorHTMLAttributes } from "react"

// TopNav's injected `linkComponent` shape — see AppLink.tsx
// (src/frontend/app/AppLink.tsx) for the full DI rationale, which
// applies unchanged here. A genuine plain <a>, not a router Link: this
// SPA has no router at all (one page, no sub-routes), and every href
// it renders — "/" (its own logo) and "/app" — is a real cross-app
// navigation regardless.
export const PublicLink = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }>(
  function PublicLink(props, ref) {
    return <a ref={ref} {...props} />
  }
)
